import ApiResponse from '@/models/ApiResponse'
import { BlogComment } from '@/models/Posts'
import { get } from '@/utils/axios'

interface Params {
  page: number
  page_size: number
  lang: string
}

const fetchBlogComments = async (url: string, params?: Partial<Params>) => {
  try {
    return await get<ApiResponse<BlogComment>>(url, params)
  } catch (e) {
    console.error(e)
  }
  return null
}

export default fetchBlogComments
